import script from "./Chat.vue?vue&type=script&setup=true&lang=js"
export * from "./Chat.vue?vue&type=script&setup=true&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=669cde21&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-669cde21"]])

export default __exports__